export default __webpack_public_path__ + "static/media/Kitchintory_img.45a69d65.png";